import React from 'react'

export default class MetricComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: '--',
      isLoading: true,
    }
  }

  componentDidMount(){
    this.fetchData()
  }

  fetchData(){
    const { organization_name, metric } = this.props
    let url = `/organizations/${organization_name}/outcomes/${metric.endpoint}.json`
    $.ajax({ url })
    .then( response => {
      this.setState((prevState, props)=>{
        return {
          isLoading: false,
          data: response.data
        }
      })
    })
  }
}